export default __webpack_public_path__ + "static/media/THSarabun.88de1d3f.ttf";